module.exports = __webpack_public_path__ + "img/zoom_out_graph.e7db7f25.svg";